import sweetAlert from '../sweet-alert';

const onRedirect = (history, url, message) => {
    sweetAlert('info', message)
        .then(() => history.push(url));
};

export default onRedirect;